export const getters = {
  carrierCredentials(state) {
    return state.carrierCredentials.carrier;
  },
};
